module.exports = __webpack_public_path__ + "static/media/Business-mission.1bcaad17.svg";